import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

export interface UploadImageResponse {
  created_at: string;
  id: number;
  image: string;
  image_thumbnail: string;
  owner: string | number;
  updated_at: number | Date;
}

@Injectable()
export class ImageService {
  constructor(private http: HttpClient) {}

  uploadImage(formData) {
    return this.http.post<UploadImageResponse>(
      environment.apiUrl + 'media/images/',
      formData
    );
  }
}
